module.exports = __webpack_public_path__ + "img/productos-participantes-sams.4b88f1c8.png";